import { Checkbox, FormControl, FormControlLabel, Grid, TextField, Typography } from '@mui/material'
import React from 'react'

export const GPSExemption = ({ useFetchInit }) => {

  const {
    //------------- Generales
    //------------- globalStates
    globalStates,
    //------------- Helpers
    Helpers,
    //------------- Formularios
    Forms,
    //------------- FetchData
    FetchData,

    defaultData,
    
    //------------- Actions
    Actions
} = useFetchInit

  const { formOpeningMode} = globalStates

  const { FormRequestGlobal:{formState, onInputChange, onInputChangeForNumber,onInputChangeForCheckBox} } = Forms

  return (
    <>
        <Typography sx={{mt:3,fontWeight: 'bold'}} variant='subtitle2'>
        Informacion sobre la gestion
        </Typography>
        <div className="border-bottom border-dark"></div>

        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2, mt: 3 }}>
            <Grid item xs={12} sm={12} md={12} lg={12} >
                <FormControl fullWidth>
                    <label htmlFor="gestion_descripcion">* Descripcion</label>
                    <TextField
                        id='gestion_descripcion'
                        name='gestion_descripcion'
                        value={ formState.gestion_descripcion } 
                        onChange={ onInputChange }
                        size='small'
                        placeholder='Descripcion'
                        type='text'
                        multiline
                        rows={5}
                        variant={(formOpeningMode==='READONLY')? 'filled': 'outlined'}
                        InputProps={{
                            readOnly: (formOpeningMode==='READONLY') ? true: false,
                            maxLength: 200
                        }}
                        required
                    />
                    <Typography
                        variant="caption"
                        align="right"
                        color={formState.gestion_descripcion.length >= 500 ? 'error' : 'textSecondary'}
                    >
                    {formState.gestion_descripcion.length} / 500
                    </Typography>
                </FormControl>
            </Grid>
        </Grid>
    </>
  )
}
